import { snapshot } from 'valtio'
import { emailRegex } from '../../../../shared/utils/formattingUtils'
import { RecurringPaymentNewProxyFormFieldNamesEnum } from './recurringPaymentNewProxyFormFieldNamesEnum'
import { recurringPaymentNewProxy } from './recurringPaymentNewProxy'

const CURRENCY_REGEX = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/

export const BASE_FIELDS_REQUIRED_FOR_SUBMISSION = [
  RecurringPaymentNewProxyFormFieldNamesEnum.Amount,
  RecurringPaymentNewProxyFormFieldNamesEnum.InvoiceNumber,
  RecurringPaymentNewProxyFormFieldNamesEnum.Customer,
  RecurringPaymentNewProxyFormFieldNamesEnum.StartDate,
  RecurringPaymentNewProxyFormFieldNamesEnum.BillingCycle
]

export const PAYMENT_METHOD_FIELD_REQUIRED_FOR_SUBMISSION = [
  RecurringPaymentNewProxyFormFieldNamesEnum.CustomerCard,
  RecurringPaymentNewProxyFormFieldNamesEnum.AchAccount
]

export function fieldsRequiredForSubmission (): RecurringPaymentNewProxyFormFieldNamesEnum[] {
  return BASE_FIELDS_REQUIRED_FOR_SUBMISSION
}

export const validators: { [key in RecurringPaymentNewProxyFormFieldNamesEnum]?: (arg0: string | Date) => string | null } = {
  [RecurringPaymentNewProxyFormFieldNamesEnum.Amount]: (val) => {
    const valU = val as string
    if (!val) { return 'Must be a positive number' }
    if (!CURRENCY_REGEX.test(valU)) { return 'Must be formatted as $00.00' }
    const parsed = parseFloat(valU)
    if (parsed <= 0) { return 'Must be a positive number' }
    return null
  },
  [RecurringPaymentNewProxyFormFieldNamesEnum.InvoiceNumber]: (val) => {
    if (!val) { return 'Must have a value' }
    return null
  },
  [RecurringPaymentNewProxyFormFieldNamesEnum.Email]: val => {
    if (!val) { return null }//They are not forced to enter an email
    if (!emailRegex.test(val as string)) { return 'Invalid email format' }
    return null
  },
  [RecurringPaymentNewProxyFormFieldNamesEnum.StartDate]: val => {
    if (!val) { return 'Must enter a start date' }
    const { form: { values } } = snapshot(recurringPaymentNewProxy)
    if (values.endDate && !(val < values.endDate)) {
      return 'Start date must be before end date'
    }
    return null
  },
  [RecurringPaymentNewProxyFormFieldNamesEnum.EndDate]: val => {
    if (!val) { return null }
    const { form: { values } } = snapshot(recurringPaymentNewProxy)
    if (values.startDate && !(values.startDate < val)) {
      return 'End date must be after start date'
    }
    return null
  }
}
